module.exports = __webpack_public_path__ + "banner_foot.png?7f4180107925891ad8d81e2d8e7fd4e6";